import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { CONTACT } from "@/i18n/translations";
import PageHero from "@/components/PageHero";
import ContactForm from "@/components/ContactForm";
import FinalCTA from "@/components/FinalCTA";
import { Reveal } from "@/components/Reveal";

const Kontakt = () => {
  const { t } = useLang();
  const k = t.kontakt;

  const info = [
    { icon: MapPin, label: k.company, value: k.address },
    { icon: Phone, label: k.form.phone, value: CONTACT.phone, href: `tel:${CONTACT.phoneRaw}` },
    { icon: Mail, label: k.form.email, value: CONTACT.email, href: `mailto:${CONTACT.email}` },
    { icon: Clock, label: k.hoursLabel, value: k.hours },
  ];

  return (
    <>
      <PageHero eyebrow={t.nav.kontakt} title={k.hero} intro={k.intro} image="https://images.unsplash.com/photo-1765366417046-f46361a7f26f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" />

      <section className="max-w-6xl mx-auto px-5 sm:px-8 py-16 lg:py-24">
        <div className="grid lg:grid-cols-[1.2fr_1fr] gap-12 lg:gap-16 items-start">
          <Reveal>
            <div className="rounded-3xl bg-white border border-black/5 p-7 sm:p-10">
              <h2 className="font-display text-3xl text-[#1A2E24] mb-7">{k.directTitle}</h2>
              <ContactForm />
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div>
              <h2 className="font-display text-3xl text-[#1A2E24] mb-7">{k.infoTitle}</h2>
              <ul className="space-y-5">
                {info.map((it) => {
                  const Icon = it.icon;
                  const content = (
                    <div className="flex items-start gap-4 rounded-2xl bg-[#EAE5D9] p-5 border border-black/5">
                      <span className="flex items-center justify-center h-11 w-11 rounded-full bg-[#2D5A3F] text-white shrink-0">
                        <Icon className="h-5 w-5" strokeWidth={1.5} />
                      </span>
                      <div>
                        <p className="text-xs uppercase tracking-[0.2em] text-[#5C7567] mb-1">{it.label}</p>
                        <p className="text-[#1A2E24] font-medium leading-snug">{it.value}</p>
                      </div>
                    </div>
                  );
                  return (
                    <li key={it.label} data-testid={`contact-info-${it.label}`}>
                      {it.href ? (
                        <a href={it.href} className="block hover:opacity-80 transition-opacity duration-300">{content}</a>
                      ) : content}
                    </li>
                  );
                })}
              </ul>
            </div>
          </Reveal>
        </div>
      </section>

      <FinalCTA />
    </>
  );
};

export default Kontakt;
